import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { LeadProvider } from "@/context/LeadContext";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function AdminGate() {
  const [token, setToken] = useState(() => localStorage.getItem("ksa_admin_token"));

  if (!token) {
    return <AdminLogin onLogin={(t) => { localStorage.setItem("ksa_admin_token", t); setToken(t); }} />;
  }
  return <AdminDashboard onLogout={() => { localStorage.removeItem("ksa_admin_token"); setToken(null); }} />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LeadProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin" element={<AdminGate />} />
          </Routes>
        </LeadProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
